// Zoho CRM Configuration
// This file contains configuration for Zoho CRM integration

export const ZOHO_CONFIG = {
  // API Configuration
  BASE_URL: process.env.REACT_APP_ZOHO_CRM_URL || 'https://www.zohoapis.com/crm/v3',
  ACCESS_TOKEN: process.env.REACT_APP_ZOHO_ACCESS_TOKEN,
  ORG_ID: process.env.REACT_APP_ZOHO_ORG_ID,
  
  // API Endpoints
  ENDPOINTS: {
    LEADS: '/Leads',
    CONTACTS: '/Contacts',
    SEARCH: '/Leads/search',
  },
  
  // Lead Statuses
  LEAD_STATUSES: {
    NEW: 'New',
    CONTACTED: 'Contacted',
    QUALIFIED: 'Qualified',
    PROPOSAL: 'Proposal',
    NEGOTIATION: 'Negotiation',
    CLOSED_WON: 'Closed Won',
    CLOSED_LOST: 'Closed Lost'
  },
  
  // Lead Sources
  LEAD_SOURCES: {
    WEBSITE: 'Website Registration',
    REFERRAL: 'Referral',
    SOCIAL_MEDIA: 'Social Media',
    EMAIL: 'Email Campaign',
    PHONE: 'Phone Call',
    OTHER: 'Other'
  },
  
  // Required Fields for Lead Creation
  REQUIRED_FIELDS: ['Last_Name', 'Mobile'],
  
  // Optional Fields for Lead Creation
  OPTIONAL_FIELDS: ['First_Name', 'Email', 'Company', 'Description', 'Lead_Source', 'Lead_Status']
};

// Development mode configuration
export const DEV_CONFIG = {
  SIMULATE_DELAY: 2000, // milliseconds
  SIMULATE_ERRORS: false,
  LOG_API_CALLS: true
};

// Helper function to check if Zoho is properly configured
export const isZohoConfigured = () => {
  return !!(ZOHO_CONFIG.ACCESS_TOKEN && ZOHO_CONFIG.ORG_ID);
};

// Helper function to get Zoho headers
export const getZohoHeaders = () => {
  return {
    'Authorization': `Zoho-oauthtoken ${ZOHO_CONFIG.ACCESS_TOKEN}`,
    'orgId': ZOHO_CONFIG.ORG_ID,
    'Content-Type': 'application/json'
  };
};
